// extracted by mini-css-extract-plugin
module.exports = {"root":"VacancyList_root__1fq1p","vacancy":"VacancyList_vacancy__3sRQP","text":"VacancyList_text__2J0RD","button":"VacancyList_button__A9tWJ"};